'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_a3020732 = {"inner":"Slider_module_inner__b696cacf","disabled":"Slider_module_disabled__b696cacf","track":"Slider_module_track__b696cacf","range":"Slider_module_range__b696cacf","handler-wrapper":"Slider_module_handlerWrapper__b696cacf","handler":"Slider_module_handler__b696cacf","active":"Slider_module_active__b696cacf","caption":"Slider_module_caption__b696cacf"};
require("../../../assets/cjs/components/Slider/src/Slider~DjaYyQ-q.css");

exports.default = modules_a3020732;
//# sourceMappingURL=Slider.module.less.js.map
